export const APP_DATE_FORMATS = {
  APP_DATE_FORMAT: 'MM/dd/yyyy HH:mm',
  APP_DATE_ONLY_FORMAT: 'MM/dd/yyyy',
  APP_TIME_ONLY_FORMAT: 'HH:mm'
} as const;